import { Switch } from "antd";
import { BulbFilled, BulbOutlined } from "@ant-design/icons";
import { useTheme } from "@/hooks/useTheme";

export function ThemeToggle() {
  const { isDark, toggle } = useTheme();

  return (
    <Switch
      aria-label="Переключить тему"
      checked={isDark}
      onChange={toggle}
      checkedChildren={<BulbFilled />}
      unCheckedChildren={<BulbOutlined />}
      size="medium"
    />
  );
}
